import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fontFace.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./RijksSansWeb-Regular.woff2%22,%22weight%22:%22200%20800%22,%22style%22:%22normal%22},{%22path%22:%22./RijksSansWeb-Italic.woff2%22,%22weight%22:%22200%20800%22,%22style%22:%22italic%22}],%22fallback%22:[%22system-ui%22,%22sans-serif%22],%22adjustFontFallback%22:false,%22display%22:%22swap%22}],%22variableName%22:%22rijksFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'rijksFont', system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
